import { createApi } from "../../../../utils/createApi";
import { WireGuardTunnel } from "./siteAboutInterfaces";

export const fetchWireguardTunnelsForCustomer = async (
  customerId: string
): Promise<WireGuardTunnel[]> => {
  const AxiosUI = createApi("");
  const allTunnels: WireGuardTunnel[] = [];
  const visitedUrls = new Set<string>();
  let nextUrl: string | null = `wireguard_tunnel/?customer=${customerId}&all_levels=true`;

  while (nextUrl) {
    if (visitedUrls.has(nextUrl)) {
      break;
    }

    visitedUrls.add(nextUrl);
    const response: {
      data?: {
        results?: WireGuardTunnel[];
        next?: string | null;
      };
    } = await AxiosUI.get<{
      results?: WireGuardTunnel[];
      next?: string | null;
    }>(nextUrl);

    allTunnels.push(...(response.data?.results ?? []));
    nextUrl = response.data?.next ?? null;
  }

  return allTunnels;
};
